import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { CertificacionI } from "interfaces/Certificacion";
import { useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createCertificacionesSchema } from "schemas/certificaciones/createCertificacionesSchema";
import { postCertificacion, putCertificacion } from "services/certificacion";
import { RootState } from "store/store";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: CertificacionI;
  onSuccess?: (certificacion: CertificacionI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
  descripcion: string;
}

export const CertificacionesABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
    descripcion: "",
  };

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
        descripcion: elemento?.descripcion ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      const newTitulo = await postCertificacion({ params });
      showSuccessToast("¡La certificación fue creada con éxito!");
      if (onSuccess) onSuccess(newTitulo);
      onClose();
    } catch (err: any) {
      showErrorToast("La certificación no pudo ser creada.");
      console.log(err.message);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      const newTitulo = await putCertificacion({ params });
      showSuccessToast("¡La certificación fue editada con éxito!");
      if (onSuccess) onSuccess(newTitulo);
      onClose();
    } catch (err: any) {
      showErrorToast("La certificación no pudo ser editada.");
      console.log(err.message);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createCertificacionesSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Certificación" : "Nueva Certificación"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={12} className="mb-3">
                  <Input
                    id={"nombre"}
                    title="Nombre de la certificación"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={12}>
                  <Input
                    id={"descripcion"}
                    title="Descripción"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="lg"
              className="user-submit-button"
              /* disabled={isSubmitting} */ type="submit"
            >
              {isEditMode ? "Guardar Cambios" : "Confirmar"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
